var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zone-component",class:{
    active: this.isActive,
    anno: this.hasAnno
  },style:(_vm.style),attrs:{"title":_vm.zoneTitle},on:{"click":function($event){$event.preventDefault();return _vm.activateZone.apply(null, arguments)}}},[(_vm.displayMeasures)?_c('div',{staticClass:"zone-label"},[_vm._v(" "+_vm._s(_vm.zoneLabel)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }